<div class="footer d-flex align-items-center text-center">
  <div class="container">
  <app-footer-link-group class="nav-item nav-link justify-self-end" [links]="links"></app-footer-link-group>
  <app-logo class="navbar-brand" [width]="60"></app-logo>
</div>
</div>
